import React from 'react';
import { cn } from '../../lib/utils';

export function PageHeader({ title, description, actions, className }) {
    return (
        <div className={cn('flex items-center justify-between mb-8', className)}>
            <div>
                <h1 className="text-3xl font-bold font-heading tracking-tight text-foreground">
                    {title}
                </h1>
                {description && (
                    <p className="mt-1 text-sm text-muted-foreground">
                        {description}
                    </p>
                )}
            </div>
            {actions && (
                <div className="flex items-center gap-3">
                    {actions}
                </div>
            )}
        </div>
    );
}
